<select class="form-select" (change)="onChange($event)" >
  <option *ngFor="let select of selects" value="{{select.value}}">{{select.label}}</option>
</select>